(function () {
  const section = document.getElementById('vg-' + window._vgSectionId);
  if (!section) return;

  /* ── Play button  iframe swap ── */
  section.querySelectorAll('.vg-play-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const wrapper = btn.closest('.vg-video-wrapper');
      const url = wrapper.dataset.embedUrl;
      if (!url) return;
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.className = 'vg-media vg-iframe';
      iframe.setAttribute(
        'allow',
        'autoplay; fullscreen; picture-in-picture; accelerometer; encrypted-media; gyroscope'
      );
      iframe.setAttribute('allowfullscreen', '');
      wrapper.querySelector('.vg-poster') && wrapper.querySelector('.vg-poster').remove();
      btn.remove();
      wrapper.appendChild(iframe);
    });
  });

  /* ── Carousel ── */
  const carousel = section.querySelector('[data-carousel]');
  if (!carousel) return;

  const track = carousel.querySelector('[data-track]');
  const slides = Array.from(track.querySelectorAll('.vg-slide'));
  const prevBtn = carousel.querySelector('[data-prev]');
  const nextBtn = carousel.querySelector('[data-next]');
  const dotsContainer = carousel.querySelector('[data-dots]');
  let dots = [];
  let current = 0;

  function perView() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 640) return 2;
    return 1;
  }

  function maxIndex() {
    return Math.max(0, slides.length - perView());
  }

  function buildDots() {
    const count = maxIndex() + 1;
    dotsContainer.innerHTML = '';
    dots = [];
    for (let i = 0; i < count; i++) {
      const btn = document.createElement('button');
      btn.className = 'vg-dot';
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.addEventListener(
        'click',
        (function (idx) {
          return function () {
            goTo(idx);
          };
        })(i)
      );
      dotsContainer.appendChild(btn);
      dots.push(btn);
    }
  }

  function goTo(index) {
    current = Math.max(0, Math.min(index, maxIndex()));
    track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    dots.forEach(function (d, i) {
      d.classList.toggle('vg-dot--active', i === current);
    });
    prevBtn.disabled = current === 0;
    nextBtn.disabled = current >= maxIndex();
  }

  prevBtn.addEventListener('click', function () {
    goTo(current - 1);
  });
  nextBtn.addEventListener('click', function () {
    goTo(current + 1);
  });

  /* sync dot on scroll */
  track.addEventListener(
    'scroll',
    function () {
      let idx = Math.round(track.scrollLeft / (slides[0] ? slides[0].offsetWidth + 24 : 1));
      idx = Math.min(idx, maxIndex());
      dots.forEach(function (d, i) {
        d.classList.toggle('vg-dot--active', i === idx);
      });
      current = idx;
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= maxIndex();
    },
    { passive: true }
  );

  /* rebuild dots on resize (perView changes) */
  window.addEventListener('resize', function () {
    buildDots();
    goTo(Math.min(current, maxIndex()));
  });

  buildDots();
  goTo(0);
})();
